





















import { BNavbarBrand, BNavbarNav, BNavbar, BNavItem, BCollapse, BNavbarToggle, BImg } from "bootstrap-vue";
// import HeroButton from "@/components/heroButton.vue";

export default {
	components: {
		BNavbarBrand,
		BNavbarNav,
		BNavbar,
		BNavItem,
		BCollapse,
		BNavbarToggle,
		BImg,
	},
};
